<template>
    <!DOCTYPE html>
    <html lang="en">
    <body>
        <page-header></page-header>
        <div>
            <div class="import-tasks-modal">
                <div class="tasks-container-fluid no-padding">
                    <div class="row">
                        <div class="col-md-12 left-align-text">
                            <h2>Import tasks from .CSV file</h2>
                            <button class="back-button" @click="goBack()">Back</button>
                            <p style="font-size:16px;">The file has to be a spreadsheet file (.csv) in the following
                                format:
                            </p>
                            <p style="font-weight:bold;">ATA|Task No|Category|Question|Assessment Type
                            </p>
                            <p style="font-size:16px; color: rgb(196, 0, 0);"><b>All fields are mandatory.</b></p>
                            <div class="instructions-area">
                                <table class="inst-table">
                                    <thead>
                                        <tr>
                                            <th>Column</th>
                                            <th>Name</th>
                                            <th>Instructions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>A</td>
                                            <td>ATA</td>
                                            <td>A valid ATA chapter Number</td>
                                        </tr>
                                        <tr>
                                            <td>B</td>
                                            <td>Task No</td>
                                            <td>A number to identify the task</td>
                                        </tr>
                                        <tr>
                                            <td>C</td>
                                            <td>Category</td>
                                            <td>Category of the task (B1, B2, B1/B2)</td>
                                        </tr>
                                        <tr>
                                            <td>D</td>
                                            <td>Question</td>
                                            <td>The question relating to the Assessment Task</td>
                                        </tr>
                                        <tr>
                                            <td>E</td>
                                            <td>Assessment Type</td>
                                            <td>Accepted values are 'airframe, powerplant, avionics, electrical'</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <span class="clip" role="img" aria-label="Paperclip">&#x1F4CE;</span>
                                <input type="file" ref="csvInput" @change="importFile" class="file-input" />
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div v-if="previewRows.length && !importSuccessful && !dryRunSuccessful">
                                <h4 style="text-align: left;">CSV Preview (First 5 rows):</h4>
                                <table class="preview-table">
                                    <!-- Uploaded CSV headers (dynamic) -->
                                    <thead>
                                        <tr>
                                            <th class="narrow-column">ATA</th>
                                            <th class="narrow-column">Task No</th>
                                            <th class="narrow-column">Category</th>
                                            <th class="wide-column">Question</th>
                                            <th class="narrow-column">Assessment Type</th>
                                        </tr>
                                    </thead>
                                    <!-- Uploaded CSV preview -->
                                    <tbody>
                                        <tr v-for="(row, index) in previewRows" :key="row.toString()"
                                            v-show="!(ignoreFirstRow && index === 0)">
                                            <td style="font-size:14px" v-for="cell in row" :key="cell">{{ cell }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="dryRunSuccessful" v-html="successMessage.replace(/\n/g, '<br>')"
                                class="successBox">
                            </div>
                            <div v-if="importSuccessful && !dryRun" v-html="successMessage.replace(/\n/g, '<br>')"
                                class="successBox"></div>
                        </div>
                        <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
                            <div v-if="errorMessage">{{ errorMessage }}</div>
                        </div>
                        <div class="importArea" style="text-align: left; padding-bottom: 10px;">
                            <label>
                                <input type="checkbox" v-model="ignoreFirstRow" class="ignoreCheckbox">
                                Ignore first row
                            </label>
                            <label>
                                <input type="checkbox" v-model="dryRun" class="dryRuncheckbox">
                                Dry Run
                            </label>
                            <div class="buttonContainer">
                                <button class="importButton" :disabled="processing" @click.stop.prevent="handleImport">
                                    {{ processing ? 'Importing...' : 'IMPORT' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </body>

    </html>
</template>

<script>
import axios from 'axios';
import pageHeader from '@/components/Examiner/Header.vue';
import './importTasks.css';
import Papa from 'papaparse';

export default {
    name: "ImportAssesementTasks",
    data() {
        return {
            productId: this.$route.params.productId,
            previewRows: [],
            entireFileRows: [],
            ignoreFirstRow: false,
            importSuccessful: false,
            dryRunSuccessful: false,
            successMessage: '',
            dryRun: true,
            importedTasks: [],
            existingTasks: [],
            fileName: '',
            sectionIds: [],
            productIds: [],
            skippedTasks: [],
            validTasks: [],
            issues: [],
            processing: false,
            showAlert: false,
            errorMessage: '',
        };
    },
    components: {
        pageHeader
    },
    watch: {
        selectedFile(newFile, oldFile) {
            if (newFile !== oldFile) {
                this.resetImportState();
            }
        }
    },
    mounted() {
        axios.get(`/api/assessment_tasks`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
            .then(response => {
                this.existingTasks = response.data;
            });
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'ViewAssessmentTasks' });
        },
        handleError(error, customMessage = '') {
            console.error('Error:', error);
            if (error.response && error.response.data && error.response.data.message) {
                this.errorMessage = `${customMessage} ${error.response.data.message}`;
            } else if (error.message) {
                this.errorMessage = `${customMessage} ${error.message}`;
            } else {
                this.errorMessage = `${customMessage} An unknown error occurred.`;
            }
            this.showAlert = true;
            this.processing = false;
        },
        importFile(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.fileName = file.name;
            if (!file.type.includes('csv') && !file.name.endsWith('.csv')) {
                this.errorMessage = 'Please upload a .csv file.';
                this.showAlert = true;
                return;
            }

            Papa.parse(file, {
                delimiter: '|',
                skipEmptyLines: true,
                quoteChar: '"',
                complete: (results) => {
                    this.entireFileRows = results.data;
                    this.previewRows = this.entireFileRows.slice(0, 5);
                },
                error: (err) => {
                    this.errorMessage = 'Error parsing CSV: ' + err.message;
                    this.showAlert = true;
                }
            });
        },
        handleImport() {
            this.dryRunSuccessful = false;
            this.processing = true;
            this.$store.dispatch('clearImportData');
            const processedTasks = this.processDataRows(this.entireFileRows);
            console.log('processedTasks');
            console.log(processedTasks);

            if (this.dryRun) {
                this.checkTasks(processedTasks);
                this.dryRunImport(processedTasks);
            } else {
                this.checkImportTasks(processedTasks);
            }

        },
        processDataRows(dataRows) {
            const rowsToProcess = this.ignoreFirstRow ? dataRows.slice(1) : dataRows;

            // Get max existing task_no
            const existingTaskNos = this.existingTasks
                .map(task => parseInt(task.task_no, 10))
                .filter(num => !isNaN(num));

            let nextTaskNo = existingTaskNos.length > 0 ? Math.max(...existingTaskNos) + 1 : 1;

            const processedTasks = rowsToProcess
                .filter(row => Array.isArray(row) && row.length > 0)
                .map((row, index) => {
                    if (index === 0 && this.isHeaderRow(row)) {
                        if (!this.ignoreFirstRow) {
                            this.issues.push({
                                message: `Row ${index + 1} appears to be a header row. Please check your file or enable "Ignore First Row".`,
                                row,
                                index,
                            });
                        }
                        // Skip processing this row but keep it for issues reporting
                        return null;
                    }
                    try {
                        const chapt_no_raw = row[0]?.trim().replace(/^"+|"+$/g, '') || '';
                        // Add padding if it's a single-digit number (e.g. "5" → "05")
                        const chapt_no = /^\d+$/.test(chapt_no_raw)
                            ? chapt_no_raw.padStart(2, '0')
                            : chapt_no_raw;

                        let task_no_raw = row[1] ? row[1].trim() : '';
                        let task_no = parseInt(task_no_raw, 10);

                        // Auto-assign if invalid or blank
                        if (isNaN(task_no)) {
                            task_no = nextTaskNo++;
                        }
                        let rawCategory = row[2]?.trim().replace(/^"+|"+$/g, '').toUpperCase() || '';
                        if (rawCategory === 'B1 B2' || rawCategory === 'B1B2' || rawCategory === 'B1,B2') {
                            rawCategory = 'B1/B2';
                        }
                        const validCategories = ['B1', 'B2', 'B1/B2'];
                        const category = validCategories.includes(rawCategory) ? rawCategory : '';
                        const question = row[3].trim();
                        const assessment_type = row[4].trim().toLowerCase();
                        const imported_task = {
                            chapt_no,
                            task_no,
                            category,
                            question,
                            assessment_type,
                        };

                        this.validateTask(imported_task, index, []);
                        return imported_task;
                    } catch (error) {
                        console.error(`Error processing row ${this.ignoreFirstRow ? index + 1 : index}:`, row, error);
                        this.issues.push({ message: `Error processing row ${this.ignoreFirstRow ? index + 1 : index}: ${error.message}`, row, index });
                        return { error: true, row, message: error.message };
                    }
                });

            console.log('dryRun', this.dryRun);

            if (this.issues.length > 0) {
                this.handleIssues(this.issues, processedTasks);
            }

            return processedTasks.filter(task => task !== null);
        },
        isHeaderRow(row) {
            const headerKeywords = ["Chapter No", "Task No", "Questions", "Logbook Entry", "CMCS fault", "Extra Info"];
            const headerMatch = headerKeywords.some(keyword =>
                row.some(cell => cell.trim().toLowerCase() === keyword.toLowerCase())
            );

            return headerMatch;
        },
        handleIssues(issues, processedTasks) {
            const uniqueIssues = [];

            issues.forEach(issue => {
                const isDuplicate = uniqueIssues.some(uniqueIssue =>
                    uniqueIssue.message === issue.message &&
                    uniqueIssue.task_no === issue.task_no &&
                    uniqueIssue.chapt_no === issue.chapt_no
                );

                if (!isDuplicate) {
                    uniqueIssues.push(issue);
                }
            });

            console.log('Filtered Issues before dispatching:', uniqueIssues);
            if (uniqueIssues.length) {
                this.$store.dispatch('setIssues', uniqueIssues);
                this.$store.dispatch('setImportedTasks', processedTasks);
                this.$store.dispatch('setFileName', this.fileName);
                this.$store.dispatch('setIgnoreFirstRow', this.ignoreFirstRow);
                if (this.dryRun) {
                    this.$router.push({ name: 'AssessmentIssuesDisplay' });
                }
            }
        },
        dryRunImport(processedTasks) {
            let dryRunSkippedTasks = [];
            const duplicates = this.checkForDuplicates(processedTasks);
            dryRunSkippedTasks = duplicates.map(task => task.task_no);
            console.log("Dry Run Mode: These tasks would have been imported:", processedTasks);
            if (dryRunSkippedTasks.length > 0) {
                console.log("Duplicate tasks that would have been skipped:", dryRunSkippedTasks);
            } else {
                this.successMessage = `Dry Run Mode: ${processedTasks.length} tasks would have been imported. No issues found in the file.`;
                console.log(this.successMessage);
            }
            this.dryRunSuccessful = true;
            this.processing = false;
        },
        async batchImportTasks(validTasks, skippedTasks, processedTasks) {
            try {
                console.log('batchValid');
                console.log(validTasks);
                console.log('batchSkipped');
                console.log(skippedTasks);
                const token = localStorage.getItem('token');
                const headers = { Authorization: `Bearer ${token}` };
                const response = await axios.post('/api/assessment_tasks/batch', validTasks, { headers });
                const responseTasks = response.data.tasks;

                console.log('Batch Import Successful:', responseTasks);
                console.log(skippedTasks);

                this.$store.dispatch('setImportedTasks', processedTasks);
                this.$store.dispatch('setFileName', this.fileName);
                this.$store.dispatch('setSkippedTasks', skippedTasks);

                this.processing = false;
                this.errorMessage = '';
                this.showAlert = false;
                this.$router.push({ name: 'importAssessmentSuccessful' });
            } catch (error) {
                this.handleError(error, 'Failed to import tasks.');
            }
        },
        areTasksEqual(task1, task2) {
            const keysToCheck = ['chapt_no', 'task_no', 'category', 'assessment_type'];

            for (let key of keysToCheck) {
                if (task1[key] !== task2[key]) {
                    return false;
                }
            }

            return true;
        },
        checkForDuplicates(importedTasks) {
            const duplicates = [];
            const seenTasks = [];

            for (let i = 0; i < importedTasks.length; i++) {
                const currentTask = importedTasks[i];

                // Check against existing tasks
                for (let existing of this.existingTasks) {
                    if (this.areTasksEqual(currentTask, existing)) {
                        duplicates.push({ task: currentTask, type: 'existing' });
                        break;
                    }
                }

                // Check against previously seen tasks in the import file
                for (let j = 0; j < seenTasks.length; j++) {
                    const seen = seenTasks[j].task;
                    if (this.areTasksEqual(currentTask, seen)) {
                        duplicates.push({
                            task: currentTask,
                            type: 'import',
                            originalRow: this.ignoreFirstRow ? seenTasks[j].index + 2 : seenTasks[j].index + 1
                        });
                        break;
                    }
                }

                // Add to seenTasks with index
                seenTasks.push({ task: currentTask, index: i });
            }

            return duplicates;
        },
        checkTasks(importedTasks, isDryRun = true) {
            this.skippedTasks = [];
            this.validTasks = [];
            console.log('importedTasks');
            console.log(importedTasks);
            const duplicates = this.checkForDuplicates(importedTasks);

            importedTasks.forEach((task, index) => {
                // If task.error exists, skip the validateTask call
                if (!task.error) {
                    // Pass the row number (index + 1) to validateTask
                    this.validateTask(task, this.ignoreFirstRow ? index : index + 1, duplicates);
                } else {
                    // Handle tasks with errors if needed (e.g., add to skippedTasks)
                    this.skippedTasks.push(task);
                }
            });

            this.handleIssues(this.issues, importedTasks, isDryRun);
        },
        checkImportTasks(importedTasks) {
            this.skippedTasks = [];
            this.validTasks = [];
            const duplicates = this.checkForDuplicates(importedTasks);

            importedTasks.forEach((task, index) => {
                // Pass the row number (index + 1) to validateTask
                this.validateTask(task, this.ignoreFirstRow ? index : index + 1, duplicates,);
            });

            // Use same issue-handling logic, but prevent route change
            this.handleIssues(this.issues, importedTasks, false); // false = not a dry run

            // Then proceed to actual import
            this.batchImportTasks(this.validTasks, this.skippedTasks, importedTasks);
        },
        validateTask(importedTask, index, duplicates) {
            try {
                const duplicateInfo = duplicates.find(d => this.areTasksEqual(d.task, importedTask));
                for (let key in importedTask) {
                    const categoryPattern = 'B1|B2|B1 B2|B1/B2'; // Define the pattern here, escape the forward slash
                    let value = importedTask[key];
                    if (key === "product_id") continue
                    switch (key) {
                        case "task_no":
                            if (value === undefined || value === null || value === '') {
                                this.issues.push({
                                    message: `Field "${key}" is empty.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            }
                            // Check for invalid data types
                            else if (isNaN(value)) {
                                this.issues.push({
                                    message: `Invalid data type for "${key}". Expected number, got ${typeof value}.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            }
                            break;
                        case "question":
                        case "chapt_no":
                            if (value === undefined || value === null || value.trim() === '') {
                                this.issues.push({
                                    message: `Field "${key}" is empty.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else if (typeof value !== "string") {
                                this.issues.push({
                                    message: `Invalid data type for "${key}". Expected string, got ${typeof value}.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            }
                            break;
                        case "category":
                            if (value === undefined || value === null || value.trim() === '') {
                                this.issues.push({
                                    message: `Field "${key}" is empty.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else if (typeof value !== "string") {
                                this.issues.push({
                                    message: `Invalid data type for "${key}". Expected string, got ${typeof value}.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else {
                                // Create a regex pattern that matches the combined scope values
                                let scopeRegex = new RegExp('^(' + categoryPattern + ')(\\|(' + categoryPattern + '))*$');
                                if (!scopeRegex.test(value)) {
                                    this.issues.push({
                                        message: `Invalid value for "${key}". Accepted values are 'B1', 'B2', 'B1/B2', 'B1 B2'.`,
                                        task_no: importedTask.task_no,
                                        chapt_no: importedTask.chapt_no,
                                        index
                                    });
                                }
                            }
                            break;
                        case "assessment_type":
                            if (value === undefined || value === null || value.trim() === '') {
                                this.issues.push({
                                    message: `Field "${key}" is empty.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else if (typeof value !== "string") {
                                this.issues.push({
                                    message: `Invalid data type for "${key}". Expected string, got ${typeof value}.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            } else if (!['airframe', 'powerplant', 'avionics', 'electrical', 'engines'].includes(value.toLowerCase())) {
                                this.issues.push({
                                    message: `Invalid value for "${key}". Accepted values are 'airframe', 'powerplant', 'avionics', 'electrical', or 'engines'.`,
                                    task_no: importedTask.task_no,
                                    chapt_no: importedTask.chapt_no,
                                    index
                                });
                            }
                            break;
                        default:
                            this.issues.push({
                                message: `Extra field "${key}" detected.`,
                                task_no: importedTask.task_no,
                                chapt_no: importedTask.chapt_no,
                                index
                            });
                    }
                }
                if (duplicateInfo) {
                    let message;
                    if (duplicateInfo.type === 'existing') {
                        message = `Row ${this.ignoreFirstRow ? parseInt(index) + 2 : index}: Task already exists in the ${this.$labels.product} (Duplicate record).`;
                    } else if (duplicateInfo.type === 'import') {
                        message = `Row ${this.ignoreFirstRow ? parseInt(index) + 2 : index}: Task is a duplicate within the import file (first seen at row ${duplicateInfo.originalRow}).`;
                    }

                    this.issues.push({
                        message,
                        task_no: importedTask.task_no,
                        chapt_no: importedTask.chapt_no,
                        index
                    });
                }
                const hasIssues = this.issues.some(issue => issue.task_no === importedTask.task_no && issue.index === index);
                if (!hasIssues) {
                    this.validTasks.push(importedTask);
                } else {
                    this.skippedTasks.push(importedTask);
                }
            } catch (error) {
                this.handleError(error, `Validation failed for Task No: ${importedTask.task_no}.`);
            }
        },
        resetImportState() {
            this.successMessage = null;
            this.previewRows = [];
            this.entireFileRows = [];
            this.processing = false;
            this.fileName = null;
            this.processedTasks = [];
            if (this.$refs.csvInput) {
                this.$refs.csvInput.value = null;
            }
        }
    },
}
</script>

<style scoped>
.importButton[disabled] {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.9;
}


.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 0rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}

label {
    float: left;
    margin-bottom: 20px;
    margin-top: 0px;
}

.back-button {
    position: absolute;
    /* Adjust the top position as needed */
    right: 60px;
    /* Adjust the right position as needed */
    width: 100px;
    border-radius: 5px;
    background-color: #c1e0bf;
    font-size: 14px;
    border: 2px solid black;
    padding: 3px;
}

.back-button:hover {
    background-color: #abc7a9;
    cursor: pointer;
}
</style>